import { create } from 'zustand'
import type { User, UserOrg } from '../types'

interface AuthState {
  user: User | null
  loading: boolean
  email_unverified: boolean
  needs_onboarding: boolean
  org_disabled: boolean
  orgs: Record<string, UserOrg>
  org_id_select: string
  setUser: (user: User | null) => void
  setLoading: (loading: boolean) => void
  set_email_unverified: (v: boolean) => void
  set_needs_onboarding: (v: boolean) => void
  set_org_disabled: (v: boolean) => void
  set_orgs: (orgs: Record<string, UserOrg>, org_id_select: string) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,
  email_unverified: false,
  needs_onboarding: false,
  org_disabled: false,
  orgs: {},
  org_id_select: '',
  setUser: (user) => set({ user }),
  setLoading: (loading) => set({ loading }),
  set_email_unverified: (v) => set({ email_unverified: v }),
  set_needs_onboarding: (v) => set({ needs_onboarding: v }),
  set_org_disabled: (v) => set({ org_disabled: v }),
  set_orgs: (orgs, org_id_select) => set({ orgs, org_id_select }),
  logout: () => set({ user: null, email_unverified: false,
    needs_onboarding: false, org_disabled: false, orgs: {}, org_id_select: '' }),
}))